/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/getFeatureFlagStatusAcrossEnvironmentsOverrides';

export type GetFeatureFlagStatusAcrossEnvironmentsPathParams = NonNullable<
  operations['getFeatureFlagStatusAcrossEnvironments']['parameters']['path']
>;

export type GetFeatureFlagStatusAcrossEnvironmentsQueryParams = NonNullable<
  operations['getFeatureFlagStatusAcrossEnvironments']['parameters']['query']
>;

export interface Input extends GetFeatureFlagStatusAcrossEnvironmentsPathParams {
  apiVersion?: string;
  query?: GetFeatureFlagStatusAcrossEnvironmentsQueryParams;
}

export async function getFeatureFlagStatusAcrossEnvironments(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/flag-status/{projectKey}/{featureFlagKey}', {
    params: { path, query },
    headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
    signal,
  });
}
